import { LucideSearch } from 'lucide-react';

export interface IEmptySearchResultProps {
  message: string;
  id?: string;
}

const EmptySearchResult = ({ message, id }: IEmptySearchResultProps) => {
  return (
    <div id={id} className={'flex justify-center items-center mt-24'}>
      <div className={'flex flex-col items-center gap-2'}>
        <LucideSearch size={48} className={'text-secondary'} />
        <div className={'text-secondary text-base'} data-testid={'empty-search-result-text'}>
          {message}
        </div>
      </div>
    </div>
  );
};

export default EmptySearchResult;
